import { CircularProgress } from '@mui/material';

function LoadingPage() {
  return <div 
  style={{position: 'absolute', top: '0', right: '0', bottom: '0', left: '0', textAlign: 'center'
        , paddingTop: '50vh', zIndex: 1500}}>
    <CircularProgress />
  </div>
}
export default LoadingPage;